import MuiDialogActions, { DialogActionsProps } from '@mui/material/DialogActions';

export interface IDialogActionsProps extends DialogActionsProps { };

const DialogActions = (props: IDialogActionsProps): JSX.Element => {
  return (
    <MuiDialogActions
      {...props}
      sx={{ ...props.sx, m: 0, p: 0, pl: 1, pr: 1, pb: 1 }}
    />
  );
};

export default DialogActions;
